/*!
* name ZJX
* Copyright 2018-2019
*/
<template>
  <div style="position: relative;z-index: 999">
    <div class="header_content">
      <div class="login_regest">
        <div v-if="userInfoData.userName" class="header_content_user">
          <p class="header_content_signout" @click="dialogVisible = true">退出</p>
          <em>|</em>
          <p class="header_content_user_name" @click="goPersonalcenter">{{userName || userInfoData.userName}}</p>
          <img @click="goPersonalcenter" :src="avatar || userInfoData.userImg" alt>
        </div>
        <div class="login_ling" v-else>
          <span class="regest" @click="register">注册</span>
          <em>|</em>
          <span class="login" @click="toLogin">登录</span>
        </div>
      </div>
    </div>
    <div class="header_content_menu">
      <div class="header_logo">
        <div class="logo" @click="handleGoHome"></div>
        <ul class="header_nav">
          <li
            :class="[item.className,item.active ? 'cur_hover':'']"
            v-for="(item,index) in muthArrList"
            :key="index"
            @click="tabMuth(item)">
            <router-link :to="item.path" tag="a">{{item.menuName}}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog title="退出" :visible.sync="dialogVisible" width="30%" :modal="false" :close-on-click-modal="false">
      <span>确定退出吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="signOut">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type='text/ecmascript-6'>
import { mapMutations, mapGetters } from 'vuex'
import cacheUtils from '@/common/cacheUtils' // 调用缓存
import apiInterface from '@/api/index' // 接口
export default {
  data () {
    return {
      dialogVisible: false, // 退出弹框
      muthArrList: [
        {
          id: 0,
          path: '/sharingcenter',
          menuName: '作品列表',
          className: 'product',
          active: true
        },
        {
          id: 1,
          path: '/resourcedownloading',
          menuName: '资源下载',
          className: 'resource',
          active: false
        },
        {
          id: 2,
          path: '/personalcenter',
          menuName: '个人中心',
          className: 'prsonal',
          active: false
        }
      ], // 导航内容
      hoverArr: ['cur_hover', '', ''],
      userInfoData: {
        userName: '',
        userImg: ''
      } // 个人信息
    }
  },
  computed: {
    ...mapGetters(['navstate', 'userName', 'avatar']),
    nav () {
      // const _nav = this.$store.getters.nav
      //const item= this.muthArrList.find(_o => {
      //   return  _o.className === this.$store.getters.nav
      // })
      return this.$store.getters.nav
    }
  },
  mounted () {},
  methods: {
    ...mapMutations({
      navState: 'SET_NAVSTATE',
      personalCenter: 'SET_PERSONALCENTER',
      curAvatar: 'SET_AVATAR',
      curNav: 'SET_NAV'
    }),
    // 模拟跳转到个人中心路由
    gopersonalcenter () {
      this.$router.push({
        path: '/personalcenter/samplereels'
      })
    },
    goPersonalcenter () {
      const _this = this
      cacheUtils.sessionStorage('status').setObject('el', 2) // 储存当前的点击状态
      let id = 2
      this.hoverArr = this.hoverArr.map((item, index) => {
        return id == index ? 'cur_hover' : ''
      })
      this.$router.push({
        path: '/personalcenter'
      })
      setTimeout(() => {
        _this.$router.go(0)
      }, 50)
    },
    // tab切换
    tabMuth (item) {
      // let id = item.id
      // this.hoverArr = this.hoverArr.map((item, index) => {
      //   return id == index ? 'cur_hover' : ''
      // })
      // cacheUtils.sessionStorage('status').setObject('el', id) // 储存当前的点击状态
      this.muthArrList.forEach(_o => {
        _o.active = false
      })
      item.active = true
      this.curNav(item.className)
    },
    // 退出系统
    signOut () {
      cacheUtils.cookie.clear()
      cacheUtils.localStorage().clear()
      cacheUtils.sessionStorage().clear()
      // this.$router.push({ path: '/' })
      window.location.href = 'http://' + document.domain
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        cacheUtils
          .sessionStorage('status')
          .setObject('zjx', pdata.data.type_id) // 储存当前的点击状态
        // pdata.data.teacher.name == null ? 'null' : pdata.data.teacher.name
        if (pdata.data.type_id == 1) {
          // this.userInfoData.userName = pdata.data.teacher == null ? 'null' : pdata.data.teacher.name == null ? 'null' : pdata.data.teacher.name;
          this.userInfoData.userName = (pdata.data.teacher == null || pdata.data.teacher.name == null) ? pdata.data.account : pdata.data.teacher.name
          this.userInfoData.userImg = (pdata.data.teacher && pdata.data.teacher.avatar) || "http://api.lehuawang.dzhhb.com/assets/system/default-user.jpg"
        } else {
          this.userInfoData.userName = (pdata.data.student == null || pdata.data.student.name == null) ? pdata.data.account : pdata.data.student.name
          this.userInfoData.userImg = (pdata.data.student && pdata.data.student.avatar) || "http://api.lehuawang.dzhhb.com/assets/system/default-user.jpg"
        }
        this.curAvatar(this.userInfoData.userImg)
      } catch (error) {
          debugger
        cacheUtils.cookie.clear()
        cacheUtils.localStorage().clear()
        cacheUtils.sessionStorage().clear()
        this.toLogin()
        // this.$message.error(error.message);
      }
    },
    // 跳转到登录页
    toLogin () {
      this.$router.push({
        path: '/',
        query: {
          id: 0,
        }
      })
    },
    // 注册
    register () {
      this.$router.push({
        path: '/',
        query: {
          id: 3,
        }
      })
    },
    handleGoHome () {
      const _this = this
      this.curNav('product')
      this.$router.push('/sharingcenter')
      setTimeout(() => {
        _this.$router.go(0)
      }, 500)
    }
  },
  created () {
    // const _this = this
    // console.log('this:', this.$store.getters)
    // if (_this.nav) {
    //   this.hoverArr = this.hoverArr.map((item, index) => {
    //     return _this.nav === index ? 'cur_hover' : ''
    //   })
    // }
    this.muthArrList.forEach(_o => {
      _o.active = _o.className === this.nav
    })
    this.accessPersonalInformation()
  },
  watch: {
    nav (val) {
      this.muthArrList.forEach(_o => {
        _o.active = _o.className === val
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header_content {
  width: 100%;
  overflow: hidden;
  background: #15c1e4;

  .login_regest {
    width: 1000px;
    margin: 0 auto;
    height: 54px;
    font: 16px/54px "Microsoft YaHei";
    color: #fff;

    .login {
      display: block;
      float: right;
      padding: 0 8px;
      cursor: pointer;
    }

    em {
      display: block;
      float: right;
      font-weight: 100;
      font-size: 12px;
    }

    .regest {
      float: right;
      padding: 0 8px;
      cursor: pointer;
    }
  }

  .header_content_user {
    color: #fff;
    height: 54px;
    float: right;
    line-height: 54px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      float: right;
      margin-top: 12px;
    }

    .header_content_user_name {
      cursor: pointer;
      float: right;
      color: #fff;
      padding: 0 8px;
      font: 16px/54px "Microsoft YaHei";
    }

    .header_content_signout {
      cursor: pointer;
      float: right;
      color: #fff;
      padding: 0 8px;
      font: 16px/54px "Microsoft YaHei";
    }

    em {
      display: block;
      float: right;
      font-weight: 100;
      font-size: 12px;
    }
  }
}

.header_content_menu {
  width: 100%;
  height: 104px;
  background: #fff;
  box-shadow: 3px 3px 10px gray;

  .header_logo {
    width: 1000px;
    margin: 0 auto;

    .logo {
      width: 97px;
      height: 62px;
      background: url(../assets/images/lh.png) no-repeat left top;
      float: left;
      margin-top: 20px;
      cursor: pointer;
    }

    .header_nav {
      float: right;
      position: relative;
      z-index: 9;

      li {
        width: 120px;
        float: left;
        height: 104px;
        text-align: center;
        transition: all 0.2s linear;

        &:hover {
          height: 130px;

          a {
            background: url(../assets/images/nav_bg.png) no-repeat center 95px;
          }
        }

        a {
          display: block;
          padding-top: 40px;
          font: 18px/64px "Microsoft YaHei";
          color: #fff;
        }
      }

      .product {
        background: #fea200;
      }

      .resource {
        background: #9dba1f;
      }

      .prsonal {
        background: #ed1d23;
      }

      .cur_hover {
        height: 130px;

        a {
          background: url(../assets/images/nav_bg.png) no-repeat center 95px;
        }
      }
    }
  }
}
</style>

